/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLabelCross: {
  name: 'label-cross';
  data: string;
} = {
  name: 'label-cross',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 3.293a1 1 0 0 1 .817-.287l9 1a1 1 0 0 1 .597.287l7 7a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1-.287-.596l-1-9a1 1 0 0 1 .287-.818Zm1.839 1.839.823 7.41L12 18.585 18.586 12 12.54 5.956l-7.41-.824Zm8.575 4.16a1 1 0 0 1 0 1.415l-.793.793.793.793a1 1 0 0 1-1.414 1.414l-.793-.793-.793.793a1 1 0 0 1-1.414-1.414l.793-.793-.793-.793a1 1 0 0 1 1.414-1.414l.793.793.793-.793a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
